import React, { PropsWithChildren } from 'react';
import cn from 'classnames/bind';

import styles from './styles.module.css';

const cx = cn.bind(styles);

interface Props {
    className?: string;
}

export const InfoBlockTitle = ({ className, children }: PropsWithChildren<Props>) => (
    <h2 className={cx('root', className)}>{children}</h2>
);
